import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';
import card from 'src/common/media/CreditDebitGrey.svg';

export const styles = makeStyles(theme => ({
  tab: {
    marginLeft: '0.366vw',
    minHeight: 'initial',
    minWidth: '4.3vw',
    height: '100%',
    padding: '2.03vh 1.53vw',
    '& span': {
      fontSize: vh(1.825),
      lineHeight: '2.086vh',
      fontWeight: 'bold',
      color: theme.palette.info.dark,
      '& svg': {
        color: theme.palette.info.main,
        fill: theme.palette.info.main,
        fontSize: vh(2.86),
      },
    },
    '&.Mui-selected': {
      '& span': {
        color: themeColor.blackpearl,
        '& svg': {
          color: theme.palette.secondary.main,
          fill: theme.palette.secondary.main,
        },
      },
    },
    '&.Mui-disabled': {
      opacity: 0.4,
    },
    '& svg': {
      width: '2.86vh',
      height: '2.86vh',
    },
    '&.Pre-swipe': {
      backgroundImage: `url(${card})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '15px',
      backgroundPosition: '99% 5%',
    },
  },
  fullWidth: {
    width: '100%',
  },
  customTabs: {
    border: `1px solid ${themeColor.secondaryLight}`,
    boxSizing: 'border-box',
    height: '6.78vh',
    '& div[role=tablist]': {
      height: '100%',
    },
    '& >*:first-child': {
      boxShadow: `8px 0px 8px 1px ${themeColor.white},
        -5px 10px 5px 2px ${themeColor.white},
        -5px -10px 5px 2px ${themeColor.white}`,
      opacity: 100,
      zIndex: 999,
      marginLeft: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },

    '& >*:last-child': {
      boxShadow: `-8px 0px 8px 1px ${themeColor.white},
        -5px 10px 5px 2px ${themeColor.white},
        -5px -10px 5px 2px ${themeColor.white}`,
      opacity: 100,
      zIndex: 999,
      marginRight: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },
  },
  allTabsContainer: {
    '& >*:first-child': {
      marginLeft: '1vw',
    },
  },
  scrollButton: {
    minWidth: '4.09vw',
    '&.Mui-disabled': {
      color: themeColor.subheaderLight,
    },
  },
  panel: {
    border: `1px solid ${themeColor.secondaryLight}`,
    borderTop: 'none',
    backgroundColor: themeColor.lightBackground,
  },
  customMaxHeight: {
    height: '100%',
    overflow: 'hidden',
    flex: '1 1 auto',
  },
}));
